module.exports = __webpack_public_path__ + "static/media/rainfall_1.0b606161.png";